import React from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router";
import { PageWrapper } from "components/Containers";
import { TimelinePage } from "components/Timeline";
import { ProfileNav } from "components/Profile";
import { useProfile } from "hooks";

/**
 * Profile Timeline
 */
const ProfileTimeline = () => {
  const { id } = useParams();
  const { data } = useProfile({ profileId: id });
  const intl = useIntl();

  return (
    <>
      <ProfileNav id={id} />
      <PageWrapper>
        <TimelinePage
          resourceId={id}
          user={data}
          pageTitle={intl.formatMessage({ id: "Meta.Profiles.Timeline.Title" })}
          subtitleId="Profile.Timeline.Title"
        />
      </PageWrapper>
    </>
  );
};

export default ProfileTimeline;
